import { apiEndpointURL } from "./endpoints-url";

export const CacheEndpoint = [
    // Reference calls
    apiEndpointURL.getCountryEndpoint,
    apiEndpointURL.campusCourseTypeEndpoint,
    apiEndpointURL.departmentTypeEndpoint,
    apiEndpointURL.intakeReferenceEndpoint,
    apiEndpointURL.courseReferenceEndpoint,
    apiEndpointURL.instanceReferenceEndpoint,
    apiEndpointURL.availabilityReferenceEndpoint,
    apiEndpointURL.feeReferenceEndpoint,
    apiEndpointURL.relatedCourseReferenceEndpoint,
    apiEndpointURL.courseGroupTypeReferenceEndpoint,
    apiEndpointURL.stagesReferenceEndpoint,
    apiEndpointURL.modulesReferenceEndpoint,
    apiEndpointURL.erReferenceEndpoint,
    apiEndpointURL.relatedInstitutionRefEndpoint,
    apiEndpointURL.institutionReferenceEndpoint,
    apiEndpointURL.nonEduOrgReferenceEndpoint,

    // Field Json calls
    apiEndpointURL.campusFieldJson + '?headerNotRequired=true',
    apiEndpointURL.departmentFieldJson + '?headerNotRequired=true',
    apiEndpointURL.intakeFieldJson + '?headerNotRequired=true',
    apiEndpointURL.courseFieldJson + '?headerNotRequired=true',
    apiEndpointURL.courseInstanceFieldJson + '?headerNotRequired=true',
    apiEndpointURL.courseAvailabilityFieldJson + '?headerNotRequired=true',
    apiEndpointURL.feeFieldJson + '?headerNotRequired=true',
    apiEndpointURL.annualFeeConstants + '?headerNotRequired=true',
    apiEndpointURL.generalCourseInstanceFieldJson + '?headerNotRequired=true',
    apiEndpointURL.generalCourseFieldJson + '?headerNotRequired=true',
    apiEndpointURL.relatedCourseFieldJson + '?headerNotRequired=true',
    apiEndpointURL.courseGroupTypeFieldJson + '?headerNotRequired=true',
    apiEndpointURL.stagesFieldJson + '?headerNotRequired=true',
    apiEndpointURL.moduleFieldJson + '?headerNotRequired=true',
    apiEndpointURL.erTestFieldJson + '?headerNotRequired=true',
    apiEndpointURL.erQualFieldJson + '?headerNotRequired=true',
    apiEndpointURL.relatedInstitutionFieldJson + '?headerNotRequired=true',
    apiEndpointURL.institutionFieldJson + '?headerNotRequired=true',
    apiEndpointURL.nonEduOrgFieldJson + '?headerNotRequired=true',

    // Misc Calls
    apiEndpointURL.countryListJson + '?headerNotRequired=true',
]
